export default {
    mounted() {
        if (this.$store.state.user) {
            this.loadCountries();
        }
        this.$bus.$on('loadCountries', this.loadCountries);
    },
    beforeDestroy() {
        this.$bus.$off('loadCountries');
    },
    methods: {
        loadCountries() {
            //load
            this.getCountries();
            //this.$socket - pending
        },
        getCountries() {
            this.$bgService.get('/country/', {params: {page: 1, pageSize: 1000, status: 0}}).then(response => {
                let countries = response.data.docs;
                this.$store.commit('countries', countries);
            });
        }
    }
}